import axios from 'axios';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useParams } from 'react-router-dom';
import { Tag } from 'primereact/tag';
import { Card } from 'primereact/card';
import { TabView, TabPanel } from 'primereact/tabview';
import { formatDatetime } from '../../Helper/constent';

const ViewSale = () => {
    const [rows, setRows] = useState([]);
    const [inactiveRows, setInactiveRows] = useState([]);
    const [SaleDetails, setSaleDetails] = useState(null);
    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const toast = useRef(null);
    const { sale_id } = useParams();
    const [loading, setLoading] = useState(true);

    const headers = apiHeadersJson;

    const fetchSaleData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Management/GetSaleProducts`, {
                params: { sale_id, type: 1 },
                headers,
            });
            const { success, data, rows, inactive_rows, message } = response.data;
            if (success) {
                setSaleDetails(data[0]);
                setRows(rows || []);
                setInactiveRows(inactive_rows || []);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data.', life: 3000 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (sale_id) {
            fetchSaleData();
        }
    }, [sale_id]);

    const renderSaleDetails = () => {
        if (!SaleDetails) return null;

        const getPaymentMethod = (method) => {
            switch (method) {
                case 1: return 'Cash';
                case 2: return 'Online';
                case 3: return 'Cash & Online';
                case 4: return 'Card';
                default: return 'N/A';
            }
        };

        return (
            <div className="grid">
                <div className="col-12 lg:col-6">
                    <Card title="Sale Information">
                        <div>
                            <p><strong>Sale ID:</strong> {SaleDetails.sale_id}</p>
                            <p><strong>Customer:</strong> {SaleDetails.customer_name}</p>
                            <p><strong>Sub Amount:</strong> ₹{SaleDetails.sub_total_amount}</p>
                            <p><strong>Discount:</strong> {SaleDetails.discount_percentage}%</p>
                            <p><strong>Total Amount:</strong> ₹{SaleDetails.grand_total_amount}</p>
                        </div>
                    </Card>
                </div>
                <div className="col-12 lg:col-6">
                    <Card title="Additional Info">
                        <div>
                            {SaleDetails.bill_by && <p><strong>Bill By:</strong> {SaleDetails.bill_by}</p>}
                            <p><strong>Date & Time:</strong> {formatDatetime(SaleDetails.created_date)}</p>
                            <p><strong>Payment Method:</strong> {getPaymentMethod(SaleDetails.payment_method)}</p>

                            {SaleDetails.payment_method === 3 && (
                                <p><strong>Cash & Online:</strong> ₹{SaleDetails.cash_amount} & ₹{SaleDetails.online_amount}</p>
                            )}

                            {SaleDetails.payment_method === 4 && (
                                <p><strong>Card:</strong> ₹{SaleDetails.card_amount}</p>
                            )}

                            {SaleDetails.last_action_by && <p><strong>Last Action By:</strong> {SaleDetails.last_action_by}</p>}
                        </div>
                    </Card>
                </div>
            </div>
        );
    };

    const actionBy = (data) => {
        let value = data.stock_status === 2 ? `Edited By ${data.user_name}` : data.stock_status === 3 ? `Deleted By ${data.user_name}` : ''
        let severity = data.stock_status == 2 ? 'info' : data.stock_status == 3 ? 'danger' : '';
        return (
            <>
                <Tag severity={severity} value={value} />
            </>
        )
    };

    const actionDateTime = (data) => {
        return (
            <>
                {formatDatetime(data.updated_date)}
            </>
        )
    };

    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="mt-4">
                {/* <h2>Sale Details</h2> */}
                {loading ? (
                    <Skeleton width="100%" height="300px" />
                ) : (
                    renderSaleDetails()
                )}
            </div>

            <div className="mt-4">
                <TabView>
                    <TabPanel header="Active Products">
                        {loading ? (
                            <Skeleton width="100%" height="200px" />
                        ) : (
                            <DataTable
                                value={rows}
                                rows={10}
                                stripedRows
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                            >
                                <Column field="product_name" header="Product Name" />
                                <Column field="product_qty" header="Quantity" />
                                <Column field="stock_purchase_price" header="Purchase Price" />
                                <Column field="stock_sale_price" header="Sale Price" />
                                <Column field="total_amount" header="Total Amount" />
                            </DataTable>
                        )}
                    </TabPanel>
                    <TabPanel header="Old Products">
                        {loading ? (
                            <Skeleton width="100%" height="200px" />
                        ) : (
                            <DataTable
                                value={inactiveRows}
                                rows={10}
                                stripedRows
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                            >
                                <Column field="product_name" header="Product Name" />
                                <Column field="product_qty" header="Quantity" />
                                <Column field="stock_purchase_price" header="Purchase Price" />
                                <Column field="stock_sale_price" header="Sale Price" />
                                <Column field="total_amount" header="Total Amount" />
                                <Column body={actionDateTime} header="Date & time" />
                                <Column header="Action By" body={actionBy} />
                            </DataTable>
                        )}
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default ViewSale;
